import classNames from 'classnames';
import { LightAlert } from 'components/shared/LightAlert';
import type { IntlKey } from 'locales';
import { FC } from 'react';
import { useIntl } from 'react-intl';

type LoadingErrorProps = {
  labelKey: IntlKey;
  severity?: 'danger' | 'warning';
  onRetry?: () => void;
};

export const LoadingError: FC<LoadingErrorProps> = ({ labelKey, onRetry, severity }) => {
  const { formatMessage } = useIntl();

  return (
    <LightAlert severity={severity ?? 'danger'}>
      <span className="flex-grow-1">{formatMessage({ id: labelKey })}</span>
      {onRetry && (
        <button
          className={classNames('btn', severity === 'warning' ? 'btn-discreet-warning' : 'btn-discreet-danger')}
          onClick={onRetry}
        >
          {formatMessage({
            id: 'discover.fetchData.retry',
          })}
        </button>
      )}
    </LightAlert>
  );
};
